<template>
  <div class="content form-fw__content">
    <div class="form__container">
      <div class="form__container__content content">
        <header class="content__header">
          <v-icon color="warning" size="64" class="content__header__icon">error_outline</v-icon>

          <h2 v-if="routeName === 'InvoiceExtendDueDateExpiredRequests'" class="content__title">
            {{ $t(`${namespace}.invoiceExtendDueDateSoldOutRequests.title`) }}<br>
            Data limite: <span>{{ dueDate }}</span>
          </h2>

          <h2 v-else class="content__title">{{ $t(`${namespace}.invoiceExtendDueDateExpiredRequests.title`) }}</h2>

          <p class="content__text" v-html="$t(`${namespace}.text`)" />
        </header>

        <ul class="content__contact">
          <li class="content__contact__item">
            <img src="./img/chat.svg" alt="" class="content__contact__icon">
            <div class="content__contact__info">
              <span class="content__contact__label">{{ $t(`${namespace}.email`) }}</span>
              <span class="content__contact__text">
                <a href="mailto:simplifica@99empresas.com">simplifica@99empresas.com</a>
              </span>
            </div>
          </li>

          <li class="content__contact__item">
            <img src="./img/phone.svg" alt="" class="content__contact__icon">
            <div class="content__contact__info">
              <span class="content__contact__label">{{ $t(`${namespace}.phone`) }}</span>
              <span class="content__contact__text">3004 9199</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Content',
  computed: {
    routeName () {
      return this.$route.name
    },

    dueDate () {
      const dueDate = new Date(Number(this.$route.params.date))
      const dueDateFormatted = moment(dueDate).add(5, 'days').format('DD/MM/YYYY')
      return dueDateFormatted
    }
  },
  data () {
    return {
      namespace: 'Views.InvoiceExtendDueDateSoldOutRequests.content'
    }
  }
}
</script>

<style lang="scss" scoped>
.content__header {
  text-align: center;
}

.content__header__icon {
  margin-bottom: 16px;
}

.content__title {
  color: $gray-8;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 16px;

  span {
    font-weight: normal;
  }
}

.content__text {
  margin-bottom: 36px;
}

.content__contact {
  align-content: center;
  display: flex;
  flex: auto;
  flex-direction: column;
  list-style-type: none;
  justify-content: center;
  max-width: 100%;
  margin: 0 auto 16px;
  padding: 0;

  @media (min-width: 1199px) {
    flex-direction: row;
    max-width: 80%;
  }
}

.content__contact__item {
  display: flex;
  margin: 8px 0;
  width: 50%;

  @media (min-width: 1199px) {
    margin: 0;
  }
}

.content__contact__icon {
  margin-right: 8px;
  max-width: 100%;
}

.content__contact__info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content__contact__label,
.content__contact__text {
  display: block;
}

.content__contact__label {
  color: $gray-8;
  font-weight: 600;
}

.content__contact__text {

  a {
    color: $accent;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
